import Swal from 'sweetalert2'


function notify(options){
    Swal.fire(Object.assign({
        position: "bottom-end",
        showConfirmButton: false,
        icon: options.type,
        timer: 1500,
        background: 'transparent',
        // backdrop: 'transparent',
        backdrop: false,
        toast: true,
    }, options));
}

class Dialog{
    static async ask(options){
        return new Promise((resolve, reject) => {
            Swal.fire(Object.assign({
              title: "Подтверждение",
              text: `Вы уверены, что хотите отклонить запрос игрока ${name}?`,
              icon: "warning",
              showCancelButton: true,
              cancelButtonColor: "#d33",
              cancelButtonText: "Отмена",
              confirmButtonColor: "#3085d6",
              confirmButtonText: "Ок",
            }, options)).then((...args) => {
                resolve(...args)
            }).catch((...args) => {
                reject(...args)
            })
        })
    }
    static toast(options){
        Swal.fire(Object.assign({
            position: "bottom-end",
            showConfirmButton: false,
            icon: options.type,
            timer: 1500,
            background: 'transparent',
            // backdrop: 'transparent',
            backdrop: false,
            toast: true,
        }, options));
    }
}

export {notify, Dialog}